import { jsx, jsxs } from "react/jsx-runtime";
import { Check, ChevronDown, ChevronUp } from "@tamagui/lucide-icons";
import { useState } from "react";
import {
  Adapt,
  Label,
  Select,
  Sheet,
  XStack,
  YStack,
  getFontSize
} from "tamagui";
import { LinearGradient } from "tamagui/linear-gradient";
function SelectDemo() {
  return /* @__PURE__ */ jsxs(YStack, { space: true, children: [
    /* @__PURE__ */ jsxs(XStack, { ai: "center", space: true, children: [
      /* @__PURE__ */ jsx(Label, { f: 1, fb: 0, children: "Custom" }),
      /* @__PURE__ */ jsx(SelectDemoItem, {})
    ] }),
    /* @__PURE__ */ jsxs(XStack, { ai: "center", space: true, children: [
      /* @__PURE__ */ jsx(Label, { f: 1, fb: 0, children: "Native" }),
      /* @__PURE__ */ jsx(SelectDemoItem, { native: true })
    ] })
  ] });
}
function SelectDemoItem(props) {
  const [val, setVal] = useState("apple");
  return /* @__PURE__ */ jsxs(Select, { id: "food", value: val, onValueChange: setVal, ...props, children: [
    /* @__PURE__ */ jsx(Select.Trigger, { width: 180, iconAfter: ChevronDown, children: /* @__PURE__ */ jsx(Select.Value, { placeholder: "Something" }) }),
    /* @__PURE__ */ jsx(Adapt, { when: "sm", platform: "touch", children: /* @__PURE__ */ jsxs(Sheet, { native: true, modal: true, dismissOnSnapToBottom: true, children: [
      /* @__PURE__ */ jsx(Sheet.Frame, { children: /* @__PURE__ */ jsx(Sheet.ScrollView, { children: /* @__PURE__ */ jsx(Adapt.Contents, {}) }) }),
      /* @__PURE__ */ jsx(Sheet.Overlay, {})
    ] }) }),
    /* @__PURE__ */ jsxs(Select.Content, { zIndex: 2e5, children: [
      /* @__PURE__ */ jsxs(
        Select.ScrollUpButton,
        {
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          width: "100%",
          height: "$3",
          children: [
            /* @__PURE__ */ jsx(YStack, { zIndex: 10, children: /* @__PURE__ */ jsx(ChevronUp, { size: 20 }) }),
            /* @__PURE__ */ jsx(
              LinearGradient,
              {
                start: [0, 0],
                end: [0, 1],
                fullscreen: true,
                colors: ["$background", "$backgroundTransparent"],
                borderRadius: "$4"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx(Select.Viewport, { minWidth: 200, children: /* @__PURE__ */ jsxs(XStack, { children: [
        /* @__PURE__ */ jsxs(Select.Group, { space: "$0", children: [
          /* @__PURE__ */ jsx(Select.Label, { children: "Fruits" }),
          items.map((item, i) => {
            return /* @__PURE__ */ jsxs(Select.Item, { index: i, value: item.name.toLowerCase(), children: [
              /* @__PURE__ */ jsx(Select.ItemText, { children: item.name }),
              /* @__PURE__ */ jsx(Select.ItemIndicator, { marginLeft: "auto", children: /* @__PURE__ */ jsx(Check, { size: 16 }) })
            ] }, item.name);
          })
        ] }),
        props.native && /* @__PURE__ */ jsx(
          YStack,
          {
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            alignItems: "center",
            justifyContent: "center",
            width: "$4",
            pointerEvents: "none",
            children: /* @__PURE__ */ jsx(ChevronDown, { size: getFontSize(props.size ?? "$true") })
          }
        )
      ] }) }),
      /* @__PURE__ */ jsxs(
        Select.ScrollDownButton,
        {
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          width: "100%",
          height: "$3",
          children: [
            /* @__PURE__ */ jsx(YStack, { zIndex: 10, children: /* @__PURE__ */ jsx(ChevronDown, { size: 20 }) }),
            /* @__PURE__ */ jsx(
              LinearGradient,
              {
                start: [0, 0],
                end: [0, 1],
                fullscreen: true,
                colors: ["$backgroundTransparent", "$background"],
                borderRadius: "$4"
              }
            )
          ]
        }
      )
    ] })
  ] });
}
const items = [
  { name: "Apple" },
  { name: "Pear" },
  { name: "Blackberry" },
  { name: "Peach" },
  { name: "Apricot" },
  { name: "Melon" },
  { name: "Honeydew" },
  { name: "Starfruit" },
  { name: "Blueberry" },
  { name: "Raspberry" },
  { name: "Strawberry" },
  { name: "Mango" },
  { name: "Pineapple" },
  { name: "Lime" },
  { name: "Lemon" },
  { name: "Coconut" },
  { name: "Guava" },
  { name: "Papaya" },
  { name: "Orange" },
  { name: "Grape" },
  { name: "Jackfruit" },
  { name: "Durian" }
];
export {
  SelectDemo,
  SelectDemoItem
};
//# sourceMappingURL=SelectDemo.js.map
